// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from '../../store'
import router from '../../router/pc/index'
import iview from 'view-design'
import 'view-design/dist/styles/iview.css';
import ipConfig from '../../../ipConfig'
import Comsys from '../../map/colorStyle'


import VueParticles from 'vue-particles'
Vue.use(VueParticles)
Vue.use(iview)
Vue.use(ipConfig)
Vue.use(Comsys)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/framework/pc/p_index.js